export default {
  uploadMediaAsset: 'UPLOAD_MEDIA_ASSET',
  updateMediaAsset: 'UPDATE_MEDIA_ASSET',
  deleteMediaAsset: 'DELETE_MEDIA_ASSET',
  bulkUploadMediaAssets: 'BULK_UPLOAD_MEDIA_ASSETS',
  mediaAssetDescription: 'MEDIA_ASSET_DESCRIPTION',
};
